var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.parada != null
    ? _c(
        "div",
        { staticClass: "detalle-datos text-wrap" },
        [
          _vm.parada.estado == "ERROR"
            ? _c("el-alert", {
                staticClass: "mt-2 mb-2",
                attrs: {
                  type: "error",
                  title:
                    _vm.parada.error ||
                    "Error en la " + _vm.tipoLabel.toLowerCase(),
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _c("div", { staticClass: "detalle-secciones" }, [
            _c("div", { staticClass: "text-break" }, [
              _c(
                "div",
                { staticClass: "h-100 px-2 pb-2" },
                [
                  _c(
                    "el-divider",
                    {
                      staticClass: "my-2",
                      attrs: { "content-position": "left" },
                    },
                    [
                      _c("h6", { staticClass: "detalle-titulo mb-0" }, [
                        _vm._v(_vm._s(_vm.tipoLabel)),
                      ]),
                    ]
                  ),
                  _c("ul", { staticClass: "list-unstyled mb-0" }, [
                    !_vm.config || _vm.config.filtros.includes("numero")
                      ? _c("li", [
                          _c("span", { staticClass: "detalle-etiqueta" }, [
                            _vm._v(_vm._s(_vm.numeroLabel) + ":"),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.showValue(_vm.parada.numero))
                          ),
                        ])
                      : _vm._e(),
                    !_vm.config ||
                    _vm.config.filtros.includes("referenciaCourier")
                      ? _c("li", [
                          _c("span", { staticClass: "detalle-etiqueta" }, [
                            _vm._v("Referencia courier:"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.showValue(_vm.parada.referenciaCourier)
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    !_vm.config || _vm.config.filtros.includes("cliente")
                      ? _c("li", [
                          _c("span", { staticClass: "detalle-etiqueta" }, [
                            _vm._v("Cliente:"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.clienteLabel)),
                        ])
                      : _vm._e(),
                    !_vm.config ||
                    _vm.config.tipo === "RECOGIDA" ||
                    _vm.config.filtros.includes("courier")
                      ? _c("li", [
                          _c("span", { staticClass: "detalle-etiqueta" }, [
                            _vm._v("Courier:"),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.formatCourier(_vm.parada.courier))
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "text-break" }, [
              _c(
                "div",
                { staticClass: "h-100 px-2 pb-2" },
                [
                  _c(
                    "el-divider",
                    {
                      staticClass: "my-2",
                      attrs: { "content-position": "left" },
                    },
                    [
                      _c("h6", { staticClass: "detalle-titulo mb-0" }, [
                        _vm._v(_vm._s(_vm.contactoLabel)),
                      ]),
                    ]
                  ),
                  _c("ul", { staticClass: "list-unstyled mb-0" }, [
                    _c("li", [
                      _c("span", { staticClass: "detalle-etiqueta" }, [
                        _vm._v("Nombre:"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.showValue(_vm.contacto.nombre))),
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "detalle-etiqueta" }, [
                        _vm._v("Atención de:"),
                      ]),
                      _vm._v(
                        " " + _vm._s(_vm.showValue(_vm.contacto.atencionDe))
                      ),
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "detalle-etiqueta" }, [
                        _vm._v("Teléfono:"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.showValue(_vm.telefonoContacto))),
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "detalle-etiqueta" }, [
                        _vm._v("Email:"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.showValue(_vm.contacto.email))),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "text-break" }, [
              _c(
                "div",
                { staticClass: "h-100 px-2 pb-2" },
                [
                  _c(
                    "el-divider",
                    {
                      staticClass: "my-2",
                      attrs: { "content-position": "left" },
                    },
                    [
                      _c("h6", { staticClass: "detalle-titulo mb-0" }, [
                        _vm._v("Ruta"),
                      ]),
                    ]
                  ),
                  _c("ul", { staticClass: "list-unstyled mb-0" }, [
                    _c("li", [
                      _c("span", { staticClass: "detalle-etiqueta" }, [
                        _vm._v("Fecha:"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.formatDate(_vm.parada.fecha))),
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "detalle-etiqueta" }, [
                        _vm._v("Horario:"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.showValue(_vm.formatHorario(_vm.parada.horario))
                          )
                      ),
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "detalle-etiqueta" }, [
                        _vm._v("Dirección:"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.showValue(_vm.parada.direccion))),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "text-break" }, [
              _c(
                "div",
                { staticClass: "h-100 px-2 pb-2" },
                [
                  _c(
                    "el-divider",
                    {
                      staticClass: "my-2",
                      attrs: { "content-position": "left" },
                    },
                    [
                      _c("h6", { staticClass: "detalle-titulo mb-0" }, [
                        _vm._v("Mercancía"),
                      ]),
                    ]
                  ),
                  _c("ul", { staticClass: "list-unstyled mb-0" }, [
                    _c("li", [
                      _c("span", { staticClass: "detalle-etiqueta" }, [
                        _vm._v("Envíos:"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.showValue(_vm.parada.red))),
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "detalle-etiqueta" }, [
                        _vm._v("Bultos:"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.showValue(_vm.parada.bultos)) +
                          " (" +
                          _vm._s(_vm.formatDecimal(_vm.parada.kilos)) +
                          " kg) "
                      ),
                    ]),
                    _c("li", [
                      _c("span", { staticClass: "detalle-etiqueta" }, [
                        _vm._v("Frío:"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.parada.frio === true
                              ? "Sí"
                              : _vm.parada.frio === false
                              ? "No"
                              : "-"
                          )
                      ),
                    ]),
                    _c("li", { staticClass: "detalle-observaciones" }, [
                      _c("span", { staticClass: "detalle-etiqueta" }, [
                        _vm._v("Observaciones:"),
                      ]),
                      _vm._v(
                        " " + _vm._s(_vm.showValue(_vm.parada.observaciones))
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }